import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styles } from "@repo/helpers";
import { useWavesurfer } from "@wavesurfer/react";
import { useCallback, useEffect, useMemo, useRef } from "react";
import HoverPlugin from "wavesurfer.js/dist/plugins/hover.esm.js";

import { Button } from "../button";
import { ButtonSize } from "../button/types";
import style from "./style.module.scss";
import { Props } from "./types";

export function AudioDisplay(props: Props) {
	const { value: audioRecording } = props;
	const {
		waveColor = "rgb(200, 0, 200)",
		progressColor = "rgb(100, 0, 100)",
		showHover = true,
		hoverLineColor = "#ff0000",
		hoverLineWidth = 2,
		hoverLabelBackground = "#555",
		hoverLabelColor = "#fff",
		hoverLabelSize = "11px",
	} = props;
	const containerRef = useRef(null);

	const hoverPlugin = HoverPlugin.create({
		lineColor: hoverLineColor,
		lineWidth: hoverLineWidth,
		labelBackground: hoverLabelBackground,
		labelColor: hoverLabelColor,
		labelSize: hoverLabelSize,
	});

	const { wavesurfer, isPlaying } = useWavesurfer({
		normalize: true,
		container: containerRef,
		waveColor: waveColor,
		progressColor: progressColor,
		interact: true,
		plugins: useMemo(() => (showHover ? [hoverPlugin] : []), [showHover]),
	});

	useEffect(() => {
		if (wavesurfer) wavesurfer.load(audioRecording?.url);
	}, [wavesurfer]);

	const onPlayPause = useCallback(() => {
		wavesurfer?.playPause();
	}, [wavesurfer]);

	const PlayPauseButton = useCallback(() => {
		if (!audioRecording) return null;
		const playIcon = <FontAwesomeIcon icon={faPlay} />;
		const pauseIcon = <FontAwesomeIcon icon={faPause} />;
		return (
			<Button onClick={onPlayPause} size={ButtonSize.large}>
				{isPlaying ? pauseIcon : playIcon}
			</Button>
		);
	}, [audioRecording, isPlaying, onPlayPause]);

	return (
		<div className={style.audioContainer}>
			<PlayPauseButton />
			<div onClick={onPlayPause} className={styles(style.recording)} ref={containerRef} />
		</div>
	);
}
